import type { ComponentType } from "react";
import BusinessLawAssignmentHelpPage from "./BusinessLawAssignmentHelpPage";
import ChangeManagementAssignmentPage from "./ChangeManagementAssignmentPage";
import PublicRelationsAssignmentHelpPage from "./PublicRelationsAssignmentHelpPage";
import StrategicManagementAssignmentHelpPage from "./StrategicManagementAssignmentHelpPage";
import LeadershipAssignmentHelpPage from "./LeadershipAssignmentHelpPage";
import BusinessEnvironmentAssignmentHelpPage from "./BusinessEnvironmentAssignmentHelpPage";
import BusinessPlanAssignmentHelpPage from "./BusinessPlanAssignmentHelpPage";
import ContractLawAssignmentHelpPage from "./ContractLawAssignmentHelpPage";
import CustomerRelationshipManagementAssignmentPage from "./CustomerRelationshipManagementAssignmentPage";
import StrategicMarketingAssignmentHelpPage from "./StrategicMarketingAssignmentHelpPage";
import CorporateLawAssignmentHelpPage from "./CorporateLawAssignmentHelpPage";
import FinancialAccountingAssignmentHelpPage from "./FinancialAccountingAssignmentHelpPage";
import BusinessIntelligenceAssignmentPage from "./BusinessIntelligenceAssignmentPage";
import CompanyLawAssignmentHelpPage from "./CompanyLawAssignmentHelpPage";
import CostAccountingAssignmentHelpPage from "./CostAccountingAssignmentHelpPage";
import BusinessManagementAssignmentHelpPage from "./BusinessManagementAssignmentHelpPage";
import BusinessDevelopmentAssignmentPage from "./BusinessDevelopmentAssignmentPage";
import MarketingManagementAssignmentHelpPage from "./MarketingManagementAssignmentHelpPage";
import HelpWithMarketingAssignmentPage from "./HelpWithMarketingAssignmentPage";
import HelpWithLawAssignmentPage from "./HelpWithLawAssignmentPage";
import CommercialLawAssignmentHelpPage from "./CommercialLawAssignmentHelpPage";
import TortLawAssignmentPage from "./TortLawAssignmentPage";
import CriminalLawAssignmentHelpPage from "./CriminalLawAssignmentHelpPage";
import CapitalBudgetingAssignmentHelpPage from "./CapitalBudgetingAssignmentHelpPage";
import OperationsManagementAssignmentHelpPage from "./OperationsManagementAssignmentHelpPage";
import ManagementAssignmentHelpPage from "./ManagementAssignmentHelpPage";
import ProjectManagementAssignmentHelpPage from "./ProjectManagementAssignmentHelpPage";
import HelpInAccountingAssignmentPage from "./HelpInAccountingAssignmentPage";
import LawAssignmentHelpPage from "./LawAssignmentHelpPage";
import MarketingAssignmentHelpPage from "./MarketingAssignmentHelpPage";
import ManagerialAccountingAssignmentHelpPage from "./ManagerialAccountingAssignmentHelpPage";
import HumanResourceManagementAssignmentHelpPage from "./HumanResourceManagementAssignmentHelpPage";
import SupplyChainManagementAssignmentHelpPage from "./SupplyChainManagementAssignmentHelpPage";
import MicroeconomicsAssignmentHelpPage from "./MicroeconomicsAssignmentHelpPage";
import EconometricsAssignmentHelpPage from "./EconometricsAssignmentHelpPage";
import BusinessAnalyticsAssignmentPage from "./BusinessAnalyticsAssignmentPage";
import HelpWithBusinessAssignmentPage from "./HelpWithBusinessAssignmentPage";
import HelpWithBusinessLawAssignmentPage from "./HelpWithBusinessLawAssignmentPage";
import IncomeStatementAssignmentPage from "./IncomeStatementAssignmentPage";
import BalanceSheetAssignmentHelpPage from "./BalanceSheetAssignmentHelpPage";
import AuditingAssignmentHelpPage from "./AuditingAssignmentHelpPage";
import PerdiscoAssignmentHelpPage from "./PerdiscoAssignmentHelpPage";
import CmiAssignmentHelpPage from "./CmiAssignmentHelpPage";
import AtheAssignmentHelpPage from "./AtheAssignmentHelpPage";
import CloudComputingAssignmentHelpPage from "./CloudComputingAssignmentHelpPage";
import ComputerGraphicsAssignmentPage from "./ComputerGraphicsAssignmentPage";
import AssemblyLanguageAssignmentHelpPage from "./AssemblyLanguageAssignmentHelpPage";
import OperatingSystemAssignmentHelpPage from "./OperatingSystemAssignmentHelpPage";
import ComputationAssignmentHelpPage from "./ComputationAssignmentHelpPage";
import AjaxAssignmentPage from "./AjaxAssignmentPage";
import DataMiningAssignmentHelpPage from "./DataMiningAssignmentHelpPage";
import DataScienceAssignmentHelpPage from "./DataScienceAssignmentHelpPage";
import ComputerNetworkAssignmentHelpPage from "./ComputerNetworkAssignmentHelpPage";
import MyobAssignmentHelpPage from "./MyobAssignmentHelpPage";
import PhpAssignmentHelpPage from "./PhpAssignmentHelpPage";
import UmlAssignmentHelpPage from "./UmlAssignmentHelpPage";
import PythonProgrammingAssignmentHelpPage from "./PythonProgrammingAssignmentHelpPage";
import DbmsAssignmentHelpPage from "./DbmsAssignmentHelpPage";
import DataAnalysisAssignmentHelpPage from "./DataAnalysisAssignmentHelpPage";
import ArtificialIntelligenceAssignmentHelpPage from "./ArtificialIntelligenceAssignmentHelpPage";
import JavaAssignmentHelpPage from "./JavaAssignmentHelpPage";
import ComputerAssignmentHelpPage from "./ComputerAssignmentHelpPage";
import HelpWithComputerScienceAssignmentPage from "./HelpWithComputerScienceAssignmentPage";
import ComputerScienceAssignmentHelpPage from "./ComputerScienceAssignmentHelpPage";
import DataStructureAssignmentHelpPage from "./DataStructureAssignmentHelpPage";
import NetworkingAssignmentHelpPage from "./NetworkingAssignmentHelpPage";
import SqlAssignmentPage from "./SqlAssignmentPage";
import StataAssignmentHelpPage from "./StataAssignmentHelpPage";
import RStudioAssignmentHelpPage from "./RStudioAssignmentHelpPage";
import RProgrammingAssignmentHelpPage from "./RProgrammingAssignmentHelpPage";
import CProgrammingAssignmentHelpPage from "./CProgrammingAssignmentHelpPage";
import HelpWithCplusplusAssignmentPage from "./HelpWithCplusplusAssignmentPage";
import CAssignmentHelpPage from "./CAssignmentHelpPage";
import CplusplusProgrammingAssignmentHelpPage from "./CplusplusProgrammingAssignmentHelpPage";
import CplusplusAssignmentHelpPage from "./CplusplusAssignmentHelpPage";
import SoftwareEngineeringAssignmentHelpPage from "./SoftwareEngineeringAssignmentHelpPage";
import HelpWithPythonAssignmentPage from "./HelpWithPythonAssignmentPage";
import PhpProgrammingAssignmentHelpPage from "./PhpProgrammingAssignmentHelpPage";
import ComputerScienceAssignmentHelpOnlinePage from "./ComputerScienceAssignmentHelpOnlinePage";
import HelpWithJavaProgrammingAssignmentPage from "./HelpWithJavaProgrammingAssignmentPage";
import HelpWithJavaAssignmentPage from "./HelpWithJavaAssignmentPage";
import CSharpAssignmentHelpPage from "./CSharpAssignmentHelpPage";
import ItAssignmentHelpPage from "./ItAssignmentHelpPage";
import PythonHomeworkAssignmentHelpPage from "./PythonHomeworkAssignmentHelpPage";
import RAssignmentHelpPage from "./RAssignmentHelpPage";
import JavaAssignmentHelpIndiaPage from "./JavaAssignmentHelpIndiaPage";
import TableauAssignmentHelpPage from "./TableauAssignmentHelpPage";
import UrgentProgrammingAssignmentHelpPage from "./UrgentProgrammingAssignmentHelpPage";
import ChemicalEngineeringAssignmentHelpPage from "./ChemicalEngineeringAssignmentHelpPage";
import BiotechnologyAssignmentHelpPage from "./BiotechnologyAssignmentHelpPage";
import AnatomyAssignmentHelpPage from "./AnatomyAssignmentHelpPage";
import AerospaceEngineeringAssignmentHelpPage from "./AerospaceEngineeringAssignmentHelpPage";
import CivilEngineeringAssignmentHelpPage from "./CivilEngineeringAssignmentHelpPage";
import FluidMechanicsAssignmentHelpPage from "./FluidMechanicsAssignmentHelpPage";
import ElectronicsEngineeringAssignmentHelpPage from "./ElectronicsEngineeringAssignmentHelpPage";
import ChemistryAssignmentHelpPage from "./ChemistryAssignmentHelpPage";
import BotanyAssignmentPage from "./BotanyAssignmentPage";
import ConstructionManagementAssignmentPage from "./ConstructionManagementAssignmentPage";
import ElectricalEngineeringAssignmentHelpPage from "./ElectricalEngineeringAssignmentHelpPage";
import MechanicalEngineeringAssignmentHelpPage from "./MechanicalEngineeringAssignmentHelpPage";
import HealthcareAssignmentHelpPage from "./HealthcareAssignmentHelpPage";
import ArchitectureAssignmentHelpPage from "./ArchitectureAssignmentHelpPage";
import ScienceAssignmentHelpPage from "./ScienceAssignmentHelpPage";
import AlgebraAssignmentHelpPage from "./AlgebraAssignmentHelpPage";
import AutocadAssignmentHelpPage from "./AutocadAssignmentHelpPage";
import SpssAssignmentPage from "./SpssAssignmentPage";
import AnovaAssignmentPage from "./AnovaAssignmentPage";
import CalculusAssignmentHelpPage from "./CalculusAssignmentHelpPage";
import HelpWithStatisticsAssignmentPage from "./HelpWithStatisticsAssignmentPage";
import MatlabAssignmentHelpPage from "./MatlabAssignmentHelpPage";
import HelpWithMatlabAssignmentPage from "./HelpWithMatlabAssignmentPage";
import StatisticsAssignmentHelpPage from "./StatisticsAssignmentHelpPage";
import HelpWithSpssAssignmentPage from "./HelpWithSpssAssignmentPage";
import ExcelAssignmentPage from "./ExcelAssignmentPage";
import BiostatisticsAssignmentHelpPage from "./BiostatisticsAssignmentHelpPage";
import ClinicalNutritionAssignmentPage from "./ClinicalNutritionAssignmentPage";
import PhysiologyAssignmentHelpPage from "./PhysiologyAssignmentHelpPage";
import ArtsAssignmentHelpPage from "./ArtsAssignmentHelpPage";
import FashionAssignmentHelpPage from "./FashionAssignmentHelpPage";
import CommunicationAssignmentHelpPage from "./CommunicationAssignmentHelpPage";
import SociologyAssignmentHelpPage from "./SociologyAssignmentHelpPage";
import GeographyAssignmentHelpPage from "./GeographyAssignmentHelpPage";
import HistoryAssignmentHelpPage from "./HistoryAssignmentHelpPage";
import HumanitiesAssignmentHelpPage from "./HumanitiesAssignmentHelpPage";
import PhilosophyAssignmentHelpPage from "./PhilosophyAssignmentHelpPage";
import BioinformaticsAssignmentHelpPage from "./BioinformaticsAssignmentHelpPage";
import GisAssignmentHelpPage from "./GisAssignmentHelpPage";
import ReligionAssignmentHelpPage from "./ReligionAssignmentHelpPage";
import SocialWorkAssignmentHelpPage from "./SocialWorkAssignmentHelpPage";
import TourismAssignmentHelpPage from "./TourismAssignmentHelpPage";
import PoliticalScienceAssignmentHelpPage from "./PoliticalScienceAssignmentHelpPage";
import PopCultureAssignmentHelpPage from "./PopCultureAssignmentHelpPage";
import PopCultureAssignmentHelpResourcesPage from "./PopCultureAssignmentHelpResourcesPage";
import AssignmentHelpCambridgePage from "./AssignmentHelpCambridgePage";
import AssignmentHelpLutonPage from "./AssignmentHelpLutonPage";
import AssignmentHelpNottinghamPage from "./AssignmentHelpNottinghamPage";
import AssignmentHelpOxfordPage from "./AssignmentHelpOxfordPage";
import AssignmentHelpLeicesterPage from "./AssignmentHelpLeicesterPage";
import AssignmentHelpWinchesterPage from "./AssignmentHelpWinchesterPage";
import AssignmentHelpGlasgowPage from "./AssignmentHelpGlasgowPage";
import AssignmentHelpPlymouthPage from "./AssignmentHelpPlymouthPage";
import AssignmentHelpCardiffPage from "./AssignmentHelpCardiffPage";
import AssignmentHelpLeedsPage from "./AssignmentHelpLeedsPage";
import AssignmentHelpBirminghamPage from "./AssignmentHelpBirminghamPage";
import AssignmentHelpEdinburghPage from "./AssignmentHelpEdinburghPage";
import AssignmentHelpBristolPage from "./AssignmentHelpBristolPage";
import AssignmentHelpManchesterPage from "./AssignmentHelpManchesterPage";
import AssignmentHelpOnlineHoustonTexasPage from "./AssignmentHelpOnlineHoustonTexasPage";
import InstantHelpAssignmentPage from "./InstantHelpAssignmentPage";
import LastMinuteAssignmentPage from "./LastMinuteAssignmentPage";
import InstantAssignmentHelpPage from "./InstantAssignmentHelpPage";
import BestAssignmentHelpWebsitesPage from "./BestAssignmentHelpWebsitesPage";
import WorkAssignmentHelpTipsResourcesPage from "./WorkAssignmentHelpTipsResourcesPage";
import CheapComputerScienceAssignmentHelpOnlinePage from "./CheapComputerScienceAssignmentHelpOnlinePage";
import MlaHeadingFormatPage from "./MlaHeadingFormatPage";

export const assignmentPageComponentMap: Record<string, ComponentType> = {
  "business-law-assignment-help": BusinessLawAssignmentHelpPage,
  "change-management-assignment-help": ChangeManagementAssignmentPage,
  "public-relations-assignment-help": PublicRelationsAssignmentHelpPage,
  "strategic-management-assignment-help": StrategicManagementAssignmentHelpPage,
  "leadership-assignment-help": LeadershipAssignmentHelpPage,
  "business-environment-assignment-help": BusinessEnvironmentAssignmentHelpPage,
  "business-plan-assignment-help": BusinessPlanAssignmentHelpPage,
  "contract-law-assignment-help": ContractLawAssignmentHelpPage,
  "customer-relationship-management-assignment-help": CustomerRelationshipManagementAssignmentPage,
  "strategic-marketing-assignment-help": StrategicMarketingAssignmentHelpPage,
  "corporate-law-assignment-help": CorporateLawAssignmentHelpPage,
  "financial-accounting-assignment-help": FinancialAccountingAssignmentHelpPage,
  "business-intelligence-assignment-help": BusinessIntelligenceAssignmentPage,
  "company-law-assignment-help": CompanyLawAssignmentHelpPage,
  "cost-accounting-assignment-help": CostAccountingAssignmentHelpPage,
  "business-management-assignment-help": BusinessManagementAssignmentHelpPage,
  "business-development-assignment-help": BusinessDevelopmentAssignmentPage,
  "marketing-management-assignment-help": MarketingManagementAssignmentHelpPage,
  "help-with-marketing-assignment": HelpWithMarketingAssignmentPage,
  "help-with-law-assignment": HelpWithLawAssignmentPage,
  "commercial-law-assignment-help": CommercialLawAssignmentHelpPage,
  "tort-law-assignment-help": TortLawAssignmentPage,
  "criminal-law-assignment-help": CriminalLawAssignmentHelpPage,
  "capital-budgeting-assignment-help": CapitalBudgetingAssignmentHelpPage,
  "operations-management-assignment-help": OperationsManagementAssignmentHelpPage,
  "management-assignment-help": ManagementAssignmentHelpPage,
  "project-management-assignment-help": ProjectManagementAssignmentHelpPage,
  "help-in-accounting-assignment": HelpInAccountingAssignmentPage,
  "law-assignment-help": LawAssignmentHelpPage,
  "marketing-assignment-help": MarketingAssignmentHelpPage,
  "managerial-accounting-assignment-help": ManagerialAccountingAssignmentHelpPage,
  "human-resource-management-assignment-help": HumanResourceManagementAssignmentHelpPage,
  "supply-chain-management-assignment-help": SupplyChainManagementAssignmentHelpPage,
  "microeconomics-assignment-help": MicroeconomicsAssignmentHelpPage,
  "econometrics-assignment-help": EconometricsAssignmentHelpPage,
  "business-analytics-assignment-help": BusinessAnalyticsAssignmentPage,
  "help-with-business-assignment": HelpWithBusinessAssignmentPage,
  "help-with-business-law-assignment": HelpWithBusinessLawAssignmentPage,
  "income-statement-assignment-help": IncomeStatementAssignmentPage,
  "balance-sheet-assignment-help": BalanceSheetAssignmentHelpPage,
  "auditing-assignment-help": AuditingAssignmentHelpPage,
  "perdisco-assignment-help": PerdiscoAssignmentHelpPage,
  "cmi-assignment-help": CmiAssignmentHelpPage,
  "athe-assignment-help": AtheAssignmentHelpPage,
  "cloud-computing-assignment-help": CloudComputingAssignmentHelpPage,
  "computer-graphics-assignment-help": ComputerGraphicsAssignmentPage,
  "assembly-language-assignment-help": AssemblyLanguageAssignmentHelpPage,
  "operating-system-assignment-help": OperatingSystemAssignmentHelpPage,
  "computation-assignment-help": ComputationAssignmentHelpPage,
  "ajax-assignment-help": AjaxAssignmentPage,
  "data-mining-assignment-help": DataMiningAssignmentHelpPage,
  "data-science-assignment-help": DataScienceAssignmentHelpPage,
  "computer-network-assignment-help": ComputerNetworkAssignmentHelpPage,
  "myob-assignment-help": MyobAssignmentHelpPage,
  "php-assignment-help": PhpAssignmentHelpPage,
  "uml-assignment-help": UmlAssignmentHelpPage,
  "python-programming-assignment-help": PythonProgrammingAssignmentHelpPage,
  "dbms-assignment-help": DbmsAssignmentHelpPage,
  "data-analysis-assignment-help": DataAnalysisAssignmentHelpPage,
  "artificial-intelligence-assignment-help": ArtificialIntelligenceAssignmentHelpPage,
  "java-assignment-help": JavaAssignmentHelpPage,
  "computer-assignment-help": ComputerAssignmentHelpPage,
  "help-with-computer-science-assignment": HelpWithComputerScienceAssignmentPage,
  "computer-science-assignment-help": ComputerScienceAssignmentHelpPage,
  "data-structure-assignment-help": DataStructureAssignmentHelpPage,
  "networking-assignment-help": NetworkingAssignmentHelpPage,
  "sql-assignment-help": SqlAssignmentPage,
  "stata-assignment-help": StataAssignmentHelpPage,
  "r-studio-assignment-help": RStudioAssignmentHelpPage,
  "r-programming-assignment-help": RProgrammingAssignmentHelpPage,
  "c-programming-assignment-help": CProgrammingAssignmentHelpPage,
  "help-with-cplusplus-assignment": HelpWithCplusplusAssignmentPage,
  "c-assignment-help": CAssignmentHelpPage,
  "cplusplus-programming-assignment-help": CplusplusProgrammingAssignmentHelpPage,
  "cplusplus-assignment-help": CplusplusAssignmentHelpPage,
  "software-engineering-assignment-help": SoftwareEngineeringAssignmentHelpPage,
  "help-with-python-assignment": HelpWithPythonAssignmentPage,
  "php-programming-assignment-help": PhpProgrammingAssignmentHelpPage,
  "computer-science-assignment-help-online": ComputerScienceAssignmentHelpOnlinePage,
  "help-with-java-programming-assignment": HelpWithJavaProgrammingAssignmentPage,
  "help-with-java-assignment": HelpWithJavaAssignmentPage,
  "c-sharp-assignment-help": CSharpAssignmentHelpPage,
  "it-assignment-help": ItAssignmentHelpPage,
  "python-homework-assignment-help": PythonHomeworkAssignmentHelpPage,
  "r-assignment-help": RAssignmentHelpPage,
  "java-assignment-help-india": JavaAssignmentHelpIndiaPage,
  "tableau-assignment-help": TableauAssignmentHelpPage,
  "urgent-programming-assignment-help": UrgentProgrammingAssignmentHelpPage,
  "chemical-engineering-assignment-help": ChemicalEngineeringAssignmentHelpPage,
  "biotechnology-assignment-help": BiotechnologyAssignmentHelpPage,
  "anatomy-assignment-help": AnatomyAssignmentHelpPage,
  "aerospace-engineering-assignment-help": AerospaceEngineeringAssignmentHelpPage,
  "civil-engineering-assignment-help": CivilEngineeringAssignmentHelpPage,
  "fluid-mechanics-assignment-help": FluidMechanicsAssignmentHelpPage,
  "electronics-engineering-assignment-help": ElectronicsEngineeringAssignmentHelpPage,
  "chemistry-assignment-help": ChemistryAssignmentHelpPage,
  "botany-assignment-help": BotanyAssignmentPage,
  "construction-management-assignment-help": ConstructionManagementAssignmentPage,
  "electrical-engineering-assignment-help": ElectricalEngineeringAssignmentHelpPage,
  "mechanical-engineering-assignment-help": MechanicalEngineeringAssignmentHelpPage,
  "healthcare-assignment-help": HealthcareAssignmentHelpPage,
  "architecture-assignment-help": ArchitectureAssignmentHelpPage,
  "science-assignment-help": ScienceAssignmentHelpPage,
  "algebra-assignment-help": AlgebraAssignmentHelpPage,
  "autocad-assignment-help": AutocadAssignmentHelpPage,
  "spss-assignment-help": SpssAssignmentPage,
  "anova-assignment-help": AnovaAssignmentPage,
  "calculus-assignment-help": CalculusAssignmentHelpPage,
  "help-with-statistics-assignment": HelpWithStatisticsAssignmentPage,
  "matlab-assignment-help": MatlabAssignmentHelpPage,
  "help-with-matlab-assignment": HelpWithMatlabAssignmentPage,
  "statistics-assignment-help": StatisticsAssignmentHelpPage,
  "help-with-spss-assignment": HelpWithSpssAssignmentPage,
  "excel-assignment-help": ExcelAssignmentPage,
  "biostatistics-assignment-help": BiostatisticsAssignmentHelpPage,
  "clinical-nutrition-assignment-help": ClinicalNutritionAssignmentPage,
  "physiology-assignment-help": PhysiologyAssignmentHelpPage,
  "arts-assignment-help": ArtsAssignmentHelpPage,
  "fashion-assignment-help": FashionAssignmentHelpPage,
  "communication-assignment-help": CommunicationAssignmentHelpPage,
  "sociology-assignment-help": SociologyAssignmentHelpPage,
  "geography-assignment-help": GeographyAssignmentHelpPage,
  "history-assignment-help": HistoryAssignmentHelpPage,
  "humanities-assignment-help": HumanitiesAssignmentHelpPage,
  "philosophy-assignment-help": PhilosophyAssignmentHelpPage,
  "bioinformatics-assignment-help": BioinformaticsAssignmentHelpPage,
  "gis-assignment-help": GisAssignmentHelpPage,
  "religion-assignment-help": ReligionAssignmentHelpPage,
  "social-work-assignment-help": SocialWorkAssignmentHelpPage,
  "tourism-assignment-help": TourismAssignmentHelpPage,
  "political-science-assignment-help": PoliticalScienceAssignmentHelpPage,
  "pop-culture-assignment-help": PopCultureAssignmentHelpPage,
  "pop-culture-assignment-help-resources": PopCultureAssignmentHelpResourcesPage,
  "assignment-help-cambridge": AssignmentHelpCambridgePage,
  "assignment-help-luton": AssignmentHelpLutonPage,
  "assignment-help-nottingham": AssignmentHelpNottinghamPage,
  "assignment-help-oxford": AssignmentHelpOxfordPage,
  "assignment-help-leicester": AssignmentHelpLeicesterPage,
  "assignment-help-winchester": AssignmentHelpWinchesterPage,
  "assignment-help-glasgow": AssignmentHelpGlasgowPage,
  "assignment-help-plymouth": AssignmentHelpPlymouthPage,
  "assignment-help-cardiff": AssignmentHelpCardiffPage,
  "assignment-help-leeds": AssignmentHelpLeedsPage,
  "assignment-help-birmingham": AssignmentHelpBirminghamPage,
  "assignment-help-edinburgh": AssignmentHelpEdinburghPage,
  "assignment-help-bristol": AssignmentHelpBristolPage,
  "assignment-help-manchester": AssignmentHelpManchesterPage,
  "assignment-help-online-houston-texas": AssignmentHelpOnlineHoustonTexasPage,
  "instant-help-assignment": InstantHelpAssignmentPage,
  "last-minute-assignment-help": LastMinuteAssignmentPage,
  "instant-assignment-help": InstantAssignmentHelpPage,
  "best-assignment-help-websites": BestAssignmentHelpWebsitesPage,
  "work-assignment-help-tips-resources": WorkAssignmentHelpTipsResourcesPage,
  "cheap-computer-science-assignment-help-online": CheapComputerScienceAssignmentHelpOnlinePage,
  "mla-heading-format": MlaHeadingFormatPage,
};
